import { useReportTokenGenerate } from '@/core/domain/reports/reportToken/reportToken.hooks';
import { ReportTokenType } from '@/core/domain/reports/reportToken/reportToken.types';
import { Button, notification } from 'antd';
import html2canvas from 'html2canvas';
import QRCode from 'react-qr-code';
import { renderToStaticMarkup } from 'react-dom/server';

interface Props {
  showQrCode?: boolean;
  selectedIndex?: number[];
  complementIdentifier?: string;
  previewRefs?: React.MutableRefObject<Record<string, HTMLDivElement | null>>;
  infosRequest: {
    complementId?: number;
    licensePlate?: string;
    companyId?: number;
    showLastServices?: boolean;
  };
}

export default function GenerateImageButton(props: Props) {
  const reportTokenGenerate = useReportTokenGenerate();

  const handleGenerateImage = async () => {
    if (!props.selectedIndex?.length) {
      return notification.warning({
        message: 'Selecione ao menos uma etiqueta',
      });
    }

    let qrCodeSvg: string | undefined;

    if (props.showQrCode) {
      const tokenData = await reportTokenGenerate.mutateAsync({
        params: JSON.stringify(props.infosRequest),
        reportType: ReportTokenType.VEHICLE_STICKER,
      });

      const qrCodeUrlWithToken = `${window.location.origin}/r/reviewEtiquette/${tokenData.token}`;

      qrCodeSvg = renderToStaticMarkup(
        <QRCode value={qrCodeUrlWithToken} size={90} />,
      );
    }

    const container = document.createElement('div');
    container.style.position = 'fixed';
    container.style.left = '0';
    container.style.background = '#fff';
    container.style.padding = '16px';
    container.style.display = 'flex';
    container.style.flexDirection = 'column';
    container.style.gap = '12px';

    document.body.appendChild(container);

    props.selectedIndex.forEach((id) => {
      const element = props.previewRefs?.current[id];
      if (!element) return;

      const clone = element.cloneNode(true) as HTMLElement;
      clone.classList.remove('selected');

      const qrCodeContainer = clone.querySelector('.etiquette-review-qrcode');

      if (qrCodeContainer && qrCodeSvg) {
        qrCodeContainer.innerHTML = qrCodeSvg;
      }

      container.appendChild(clone);
    });

    const canvas = await html2canvas(container, {
      scale: 4,
      backgroundColor: '#FFFFFF',
    });

    const link = document.createElement('a');
    link.href = canvas.toDataURL('image/png');
    link.download = `etiquetas-${props.complementIdentifier}.png`;
    link.click();

    document.body.removeChild(container);
  };

  return (
    <Button
      onClick={handleGenerateImage}
      loading={reportTokenGenerate.isLoading}
    >
      Baixar como imagem
    </Button>
  );
}
